@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.manage-tag-modal {
  width: 445px;
}

.tag-pill {
  margin-top: 7px;
  max-width: 100%;
}

.modal-body {
  padding: 15px;
  max-height: 545px;
  overflow: auto;
}

.no-tags-message {
  width: 100%;
  padding: 10px 0;
  font-size: 13px;
  color: @manage-tags-modal--no-tags-message--text-color;
  text-align: center;
  font-style: italic;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
}

.loading-indicator {
  width: 100%;
  height: 300px;
}
